<template>
  <div class="unbind_pop">
    <p>请填写手机短信验证码</p>
    <p class="phone">{{ msg }}</p>
    <div class="send_success" v-if="show">验证码已发送</div>
    <div class="flex center">
      <div class="otpInputs">
        <el-input
          v-model="code"
          type="number"
          oninput="if(value.length > 6) value=value.slice(0, 6)"
        >
        </el-input>
        <span class="code_list">{{ code1 }}</span>
        <span class="code_list">{{ code2 }}</span>
        <span class="code_list">{{ code3 }}</span>
        <span class="code_list">{{ code4 }}</span>
        <span class="code_list">{{ code5 }}</span>
        <span class="code_list last_code_list">{{ code6 }}</span>
      </div>
    </div>
    <div class="btns">
      <el-button
        class="send_code"
        :disabled="isdisabled"
        type="warning"
        @click="sendCode"
        >重新发送<i v-if="time > 0">{{ time }}s</i></el-button
      >
      <el-button @click="unbind" type="primary" :loading="loading > 0"
        >确定</el-button
      >
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
export default {
  data() {
    return {
      app_id: this.selection.app_id,
      account_id: this.selection.account_id,
      msg: '',
      code: "",
      code1: "",
      code2: "",
      code3: "",
      code4: "",
      code5: "",
      code6: "",
      show: false,
      isdisabled: true,
      time: 59,
      loading: 0,
    };
  },
  mounted() {
   this.sendCode()
  },
  methods: {
    sendCode() {
      setTimeout(() => {
        $('.otpInputs input').focus()
      },100)
      this.isdisabled = true;
      this.$Ajax("user-info/unbind", {app_id: this.app_id,account_id: this.account_id},'get').then(rs => {
        if (rs.code == 200) {
          var that = this;
          this.msg = rs.msg
          this.show = true;
          setTimeout(() => {
            that.show = false;
          }, 2000);
          that.time = 59;
          let interval = window.setInterval(function () {
            that.time--;
            if (that.time < 0) {
              that.isdisabled = false;
              window.clearInterval(interval);
            }
          }, 1000);
        } else {
          this.show = false;
          this.isdisabled = false;
          this.time = 0;
        }
      });
    },
    unbind() {
      var that = this;
      this.loading++;
      this.$Ajax("user-info/unbind-submit", {
        account_id: this.account_id,
        code: this.code
      })
        .then(rs => {
          if (rs.code == 200) {
            this.$emit("success");
          }
        })
        .finally(() => {
          setTimeout(() => {
            that.loading = 0;
          }, 2000);
        });
    },
  },
  watch: {
    code(val) {
      let arr = val.split("");
      this.code1 = arr[0];
      this.code2 = arr[1];
      this.code3 = arr[2];
      this.code4 = arr[3];
      this.code5 = arr[4];
      this.code6 = arr[5];
    },
  },
};
</script>
<style lang="less" scoped>
.unbind_pop {
  position: relative;
  .send_success {
    position: absolute;
    top: 7rem;
    left: 50%;
    transform: translateX(-50%);
    background-color: #444;
    color: #fff;
    border-radius: 0.4rem;
    width: 20.2rem;
    height: 4rem;
    line-height: 4rem;
    text-align: center;
    z-index: 10;
    font-size: 1.3rem;
  }
  p {
    font-size: 1.6rem;
    text-align: center;
    margin-bottom: 1.2rem;
  }
  .phone {
    font-size: 1.5rem;
  }
  /deep/.el-input {
    .el-input__inner {
      border: none;
      width: 18rem;
      margin: 0 auto;
    }
  }
  .flex {
    overflow: hidden;
    margin-bottom: 2.5rem;
  }
  .otpInputs {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: relative;

    /deep/.el-input {
      position: absolute;
      padding-left: 2rem;

      .el-input__inner {
        width: 23rem;
        padding: 0;
        margin: 0 auto;
        letter-spacing: 3.7rem;
        color: transparent;
        background-color: transparent;
        border: none;
        &:focus {
          caret-color: #000; /* 设置光标颜色为黑色 */
        }
      }
    }
  }

  .code_list {
    display: inline-block;
    width: 4rem;
    height: 4rem;
    line-height: 4rem;
    text-align: center;
    font-size: 1.4rem;
    border-left: none;
    border-right: none;
    border-top: none;
    border-bottom: 0.1rem solid #bbb;
    margin-right: 0.5rem;
  }

  .last_code_list {
    margin-right: 0;
  }
  .btns {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 0 2rem;
    .el-button {
        padding: 0;
        width: 44%;
        height: 3rem;
        border-radius: 10rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.3rem;
    }
  }
}
</style>
